/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ClearProfilePhotoInternalRequest} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/clear_profile_photo_internal.pb'
import {ClearProfilePhotoInternalResponse} from '@cash-web/protos/squareup/cash/cashcustomerprofile/api/v1/clear_profile_photo_internal.pb'


export const clearProfilePhotoInternal = (request: ClearProfilePhotoInternalRequest, options?: CashRequestOptions) => post<ClearProfilePhotoInternalRequest, ClearProfilePhotoInternalResponse>("/2.0/cash/clear-profile-photo-internal", request, {...options, rejectOnError: true })